export enum QuestionType {
    DISCLOSURE = "Disclosure",
    DISCLOSURES = "Disclosures",
    QUESTION_LIST = "QuestionList",
    CHECKLIST = "CheckList",
    RADIOLIST = "RadioList",
    SINGLE_TEXT = "SingleText"
}
